module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_14_sp-4eaf59e201f1273e0f5703fdf623541d.png";